if (!customElements.get('sumitomo-industries')) {
  customElements.define(
    'sumitomo-industries',
    class SumitomoIndustries extends HTMLElement {
      connectedCallback() {
        this.pills = [...this.querySelectorAll('[data-industry-pill]')];
        this.panels = [...this.querySelectorAll('[data-industry-panel]')];
        this.pills.forEach((pill, i) => pill.addEventListener('click', () => this.select(i)));

        // /pages/industries#die-mould opens that industry (the homepage tiles link this way).
        this.selectFromHash();
        window.addEventListener('hashchange', () => this.selectFromHash());

        // Theme editor: reveal the industry whose block is selected.
        document.addEventListener('shopify:block:select', (e) => {
          const i = this.pills.indexOf(e.target);
          if (i >= 0) this.select(i);
        });
      }

      selectFromHash() {
        const id = decodeURIComponent(window.location.hash.slice(1));
        const i = id ? this.pills.findIndex((pill) => pill.id === id) : -1;
        if (i < 0) return;
        this.select(i);
        this.pills[i].scrollIntoView({ block: 'start' });
      }

      select(index) {
        this.pills.forEach((pill, i) => {
          pill.classList.toggle('active', i === index);
          pill.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        this.panels.forEach((panel, i) => (panel.hidden = i !== index));
      }
    }
  );
}
